module.exports = __webpack_public_path__ + "static/gary-c85074e6850864f3ea305a0d8af0185c.png";